import { ChangeDetectorRef, Component, Injector, Input } from "@angular/core";
import { AppComponentBase } from "@shared/app-component-base";

@Component({
    selector: 'expandable',
    templateUrl: './expandable.component.html',
    styleUrls: ['./expandable.component.scss'],
})
export class ExpandableComponent extends AppComponentBase {
    @Input() titulo: string;
    @Input() icone: string;
    @Input() alertas: number = 0;
    protected expanded: boolean = false;

    constructor(
        injector: Injector,
        private _cdr: ChangeDetectorRef
    ) { super(injector) }

    protected toggleExpand(): void {
        this.expanded = !this.expanded;
        this._cdr.detectChanges();
    }

    protected get showAlertas(): boolean {
        return this.alertas > 0;
    }
}
